import { browser } from '$app/environment';
import { env } from '$env/dynamic/public';

let isGoogleApiConnected = false;
let isGoogleApiLoading = false;
let callBacks = [];

export const googleApiLoad = (callback: () => void) => {
  if (!browser) return;

  if (isGoogleApiConnected) {
    return callback();
  }

  if (isGoogleApiLoading) {
    callBacks.push(callback);
    return;
  }

  callBacks.push(callback);

  isGoogleApiLoading = true;

  try {
    const src = `https://maps.googleapis.com/maps/api/js?key=${env.PUBLIC_GOOGLE_API_KEY}&libraries=places&language=en&callback=Function.prototype`;
    const head = document.querySelector('head');
    const script = document.createElement('script');

    script.src = src;
    script.addEventListener('load', () => {
      isGoogleApiLoading = false;
      isGoogleApiConnected = true;

      callBacks.forEach(cb => {
        try {
          cb();
        } catch (error) {
          console.error(error);
        }
      });
    });

    head.appendChild(script);
  } catch (err) {
    console.error('map-error', err);
  }
};
